import { render, staticRenderFns } from "./ehc-white-label-footer-btn.vue?vue&type=template&id=439462cd"
import script from "./ehc-white-label-footer-btn.vue?vue&type=script&lang=js"
export * from "./ehc-white-label-footer-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports